import React, {memo} from "react";
import PropTypes from "prop-types";

const EmptyData = ({children}) => {
  return (
    <div
      style={{
        width: "100%",
        height: "56px",
      }}
    >
      <span style={{fontSize: "32px"}}>{children}</span>
    </div>
  );
};

EmptyData.propTypes = {
  children: PropTypes.string,
};

export default memo(EmptyData);
